import React from "react";
import { Component } from "react";
import { CostLineChartData } from "../line-chart/cost-line-chart.component";
import "./cost-report-line-chart.component.css";
import {ChartHeaderDropdown} from "../../../../common/data-header/chart-header-dropdown.component";
export class CorstReportLineChart extends Component {
    render() {     

      const data=[{
        headerName:"Top 5 Regions",
        legendName: [
         { legendTitle: "Region 1", fill:"#ff7f0e"},
         { legendTitle: "Region 2", fill:"#28a745"},
        ] ,      
       
        region:[    
                  
             [         
                {name: 1000,  pv: 2400,  xVal:"Sample  1", linecolor:"#ff7f0e"},
                {name: 2000,  pv: 1398,  xVal:"Sample 2", },
                {name: 3000,  pv: 4800,  xVal:"Sample 3", },
                {name: 4000,  pv: 3908,  xVal:"Sample 4"},
                {name: 5000,  pv: 800,  xVal:"Sample 5"},
              ],
              
             [
                
                 {name: 1000, pv: 4000, xVal:"Series 6", linecolor:"#28a745"},
                 {name: 4000, pv: 3490, xVal:"Series 7"},
              ]
            ] 
       }, {
        headerName:"Top 5 Cost Center",
        legendName: [
         { legendTitle: "Region 1", fill:"#ff7f0e"},
         { legendTitle: "Region 2", fill:"#28a745"},
        ] ,      
       
        region:[    
                  
             [         
                {name: 1000,  pv: 2400,  xVal:"Sample  1", linecolor:"#ff7f0e"},
                {name: 2000,  pv: 1398,  xVal:"Sample 2", },
                {name: 3000,  pv: 4800,  xVal:"Sample 3", },
                {name: 4000,  pv: 3908,  xVal:"Sample 4"},
                {name: 5000,  pv: 800,  xVal:"Sample 5"},
              ],
              
             [
                
                 {name: 1000, pv: 4000, xVal:"Series 6", linecolor:"#28a745"},
                 {name: 4000, pv: 3490, xVal:"Series 7"},
              ]
            ] 
       }, {
        headerName:"Top 5 Teams",
        legendName: [
         { legendTitle: "Region 1", fill:"#ff7f0e"}
        
        ] ,      
       
        region:[    
                  
             [         
                {name: 1000,  pv: 2400,  xVal:"Sample  1", linecolor:"#ff7f0e"},
                {name: 2000,  pv: 1398,  xVal:"Sample 2", },
                {name: 3000,  pv: 4800,  xVal:"Sample 3", },
                {name: 4000,  pv: 3908,  xVal:"Sample 4"},
                {name: 5000,  pv: 800,  xVal:"Sample 5"},
              ]
            ] 
       }]


        return(
            <div className="cost-table-chart">
                {data.map((item,id)=>
                    <div className="cost-table-list-container" key={id}>                      
                         <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={false} headerName={item.headerName} circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                          haveInput={false} haveDropdown={false}   />                   
                         <CostLineChartData data={item.region} lineColor={item.lineColor} />
                         {item.legendName !== undefined ? 
                              <div className="ledgend-container">
                                {item.legendName.map((list, listid)=>
                                  <div key={listid} className="ledgend-wrapper">
                                        <div className={(list.legendTitle.toString().toLowerCase().replace(" ", "") + "-legend-name-fill") + " ledgend-container-icon"}></div>
                                    <h1 className="ledgend-header">
                                         { list.legendTitle}
                                    </h1>
                                  </div>
                                ) }
                              </div>
                              : ""
                          }
                       
                    </div>
                    
                )}
               
            </div>
        )
    }
}